export const resolveYouTubeUrl = (url: string): string | undefined => {
  if (!url) return undefined;
  if (!/youtu\.?be/.test(url)) return undefined;

  // Define patterns to match various YouTube URL formats
  const patterns = [
    // youtu.be/<id>
    /youtu\.be\/([^#\&\?]{11})/,
    // ?v=<id>
    /\?v=([^#\&\?]{11})/,
    // &v=<id>
    /\&v=([^#\&\?]{11})/,
    // embed/<id>
    /embed\/([^#\&\?]{11})/,
    // e/<id>
    /e\/([^#\&\?]{11})/,
    // /v/<id>
    /\/v\/([^#\&\?]{11})/,
    // /watch/<id>
    /\/watch\/([^#\&\?]{11})/,
    // /shorts/<id>
    /\/shorts\/([^#\&\?]{11})/,
  ];

  // If any pattern matches, return the computed YouTube URL
  for (const pattern of patterns) {
    if (!pattern.test(url)) continue;
    const v = pattern.exec(url)?.at(1);

    return `https://www.youtube.com/watch?v=${v}`;
  }
};
